/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface PortfolioWorkGallery
 */
export interface PortfolioWorkGallery {
  /**
   *
   * @type {number}
   * @memberof PortfolioWorkGallery
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof PortfolioWorkGallery
   */
  image?: string | null
  /**
   *
   * @type {string}
   * @memberof PortfolioWorkGallery
   */
  video?: string
  /**
   *
   * @type {number}
   * @memberof PortfolioWorkGallery
   */
  innerId: number
  /**
   *
   * @type {boolean}
   * @memberof PortfolioWorkGallery
   */
  isMain?: boolean
}

/**
 * Check if a given object implements the PortfolioWorkGallery interface.
 */
export function instanceOfPortfolioWorkGallery(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'innerId' in value

  return isInstance
}

export function PortfolioWorkGalleryFromJSON(json: any): PortfolioWorkGallery {
  return PortfolioWorkGalleryFromJSONTyped(json, false)
}

export function PortfolioWorkGalleryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PortfolioWorkGallery {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    image: !exists(json, 'image') ? undefined : json['image'],
    video: !exists(json, 'video') ? undefined : json['video'],
    innerId: json['innerId'],
    isMain: !exists(json, 'isMain') ? undefined : json['isMain'],
  }
}

export function PortfolioWorkGalleryToJSON(value?: PortfolioWorkGallery | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    image: value.image,
    video: value.video,
    innerId: value.innerId,
    isMain: value.isMain,
  }
}
